import { motion } from 'motion/react';
import React from 'react';

interface SectionHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  pill?: string;
  align?: 'left' | 'center';
  className?: string;
  maxWidth?: string;
  invert?: boolean;
}

export function SectionHeader({ 
  title, 
  subtitle, 
  pill, 
  align = 'center',
  className = '',
  maxWidth = 'max-w-3xl',
  invert = false
}: SectionHeaderProps) {
  const alignClass = align === 'center' ? 'text-center items-center' : 'text-left items-start';

  return (
    <div className={`flex flex-col ${alignClass} ${className} ${maxWidth} ${align === 'center' ? 'mx-auto' : ''}`}>
      {pill && (
        <motion.span
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className={`px-3 py-1 ${invert ? 'bg-white/10 text-white border-white/20' : 'bg-[#ff5d22]/5 text-[#ff5d22] border-[#ff5d22]/10'} text-[8px] sm:text-[9px] font-black uppercase tracking-[0.12em] sm:tracking-[0.2em] rounded-full mb-4 sm:mb-6 border backdrop-blur-sm text-center leading-tight`}
        >
          {pill}
        </motion.span>
      )}
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.1 }}
        className={`text-2xl sm:text-3xl md:text-5xl font-black tracking-tighter leading-tight md:leading-[0.95] mb-4 sm:mb-6 ${invert ? 'text-white' : 'text-black'}`}
      >
        {title}
      </motion.h2>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className={`text-sm sm:text-base ${invert ? 'text-white/50' : 'text-black/50'} leading-relaxed font-bold`}
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
}
